export const PENDING = 'Pending';
export const PROGRESS = 'In Progress';
export const COMPLETE = 'Completed';
export const SENT = 'Sent';
